/* =========================================================
   SVHAINE SHOP — JS GLOBAL (assets/svhaine-shop.js)
   - Clic carte => fiche produit (modale "pack" désactivée)
   - Dropdowns (langue) : 1 seul handler propre
   - Hero carousel (auto 6s)
   - Mobile drawer (burger)
   ========================================================= */

(function () {
  // -------------------------
  // Helpers
  // -------------------------
  const qs = (id) => document.getElementById(id);

  function safeJsonParse(str, fallback) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return fallback;
    }
  }

  // -------------------------
  // Modal open/close
  // (conservé au cas où, mais plus déclenché)
  // -------------------------
  function openModal() {
    const modal = qs("packModal");
    if (!modal) return;
    modal.style.display = "flex";
    document.documentElement.style.overflow = "hidden";
  }

  function closeModal() {
    const modal = qs("packModal");
    if (!modal) return;
    modal.style.display = "none";
    document.documentElement.style.overflow = "";
  }

  // Expose for inline onclick="closeModal()" if present
  window.closeModal = closeModal;
  window.openModal = openModal;

  // -------------------------
  // Render pack contents (left column)
  // -------------------------
  function renderPackItems(items) {
    const listEl = qs("packItemsList");
    const countEl = qs("packItemsIncluded");
    const imgEl = qs("packImage");

    if (!listEl) return;

    // Clean
    listEl.innerHTML = "";

    // Count label (Pack contents / 4 items included)
    if (countEl) {
      const n = Array.isArray(items) ? items.length : 0;
      countEl.textContent = countEl.textContent.replace(/\d+/, String(n));
      if (!/\d+/.test(countEl.textContent)) {
        countEl.textContent = String(n) + " " + countEl.textContent;
      }
    }

    if (!Array.isArray(items) || items.length === 0) {
      const empty = document.createElement("div");
      empty.style.color = "#777";
      empty.style.fontSize = "12px";
      empty.style.padding = "10px 6px";
      empty.textContent = "—";
      listEl.appendChild(empty);
      return;
    }

    let activeIndex = 0;

    items.forEach((it, idx) => {
      const row = document.createElement("button");
      row.type = "button";
      row.className = "svhaine-item-row" + (idx === activeIndex ? " active" : "");
      row.setAttribute("data-pack-item", String(idx));

      const icon = document.createElement("div");
      icon.className = "svhaine-item-icon";
      if (it.thumb) {
        const im = document.createElement("img");
        im.src = it.thumb;
        im.alt = it.name || "Item";
        im.loading = "lazy";
        im.width = 24;
        im.height = 24;
        im.style.display = "block";
        im.style.borderRadius = "4px";
        icon.textContent = "";
        icon.appendChild(im);
      } else {
        icon.textContent = "•";
      }

      const txt = document.createElement("div");
      txt.className = "svhaine-item-text";

      const h4 = document.createElement("h4");
      h4.textContent = it.name || "Item";

      const span = document.createElement("span");
      span.className = "svhaine-type-blue";
      span.textContent = it.type || "";

      txt.appendChild(h4);
      txt.appendChild(span);

      row.appendChild(icon);
      row.appendChild(txt);

      row.addEventListener("click", () => {
        listEl.querySelectorAll(".svhaine-item-row").forEach((x) => x.classList.remove("active"));
        row.classList.add("active");
        if (imgEl && it.img) {
          imgEl.src = it.img;
          imgEl.alt = it.name || "Item";
        }
      });

      listEl.appendChild(row);
    });

    const first = items[0];
    if (imgEl && first && first.img) {
      imgEl.src = first.img;
      imgEl.alt = first.name || "Item";
    }
  }

  // -------------------------
  // Fill modal content
  // -------------------------
  function setModalContent(data) {
    const titleEl = qs("packTitle");
    const imgEl = qs("packImage");
    const descEl = qs("packDesc");
    const priceEl = qs("packPrice");
    const artistEl = qs("packArtist");
    const materialsEl = qs("packMaterials");
    const linkEl = qs("packProductLink");

    if (titleEl) titleEl.textContent = data.title || "";
    if (imgEl && data.image) imgEl.src = data.image;
    if (imgEl) imgEl.alt = data.title || "Pack";

    if (descEl) descEl.textContent = data.desc || "";

    if (priceEl) priceEl.textContent = data.price || "—";

    if (artistEl) artistEl.textContent = data.vendor || "—";
    if (materialsEl) materialsEl.textContent = data.materials || "—";

    if (linkEl) linkEl.href = data.url || "#";

    renderPackItems(data.packItems || []);
  }

  // -------------------------
  // Open pack click (delegation)
  // MODIFIE : on n'ouvre plus la modale, on va directement a la fiche produit
  // -------------------------
  function onOpenPackClick(e) {
    const btn = e.target.closest("[data-pack-open]");
    if (!btn) return;
    e.preventDefault();
    // Va directement a la fiche produit (modale desactivee)
    const url = btn.dataset.url || btn.getAttribute("href") || "";
    if (url) window.location.href = url;
  }

  document.addEventListener("click", onOpenPackClick);

  // Fermer si clic sur l’overlay
  document.addEventListener("click", (e) => {
    const modal = qs("packModal");
    if (!modal) return;
    if (e.target === modal) closeModal();
  });

  // Fermer ESC
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeModal();
  });

  // -------------------------
  // Dropdowns (langue) — 1 seul handler propre
  // -------------------------
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".svhaine-dd__btn");
    const dd = e.target.closest(".svhaine-dd");
    const all = document.querySelectorAll(".svhaine-dd");

    if (btn && dd) {
      e.preventDefault();
      all.forEach((x) => {
        if (x !== dd) x.classList.remove("is-open");
      });
      dd.classList.toggle("is-open");
      return;
    }

    all.forEach((x) => x.classList.remove("is-open"));
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      document.querySelectorAll(".svhaine-dd").forEach((x) => x.classList.remove("is-open"));
    }
  });

  // -------------------------
  // Hero carousel (auto 6s)
  // -------------------------
  (function () {
    const root = document.querySelector("[data-hero-carousel]");
    if (!root) return;

    const track = root.querySelector("[data-hero-track]");
    const slides = Array.from(root.querySelectorAll("[data-hero-slide]"));
    const prev = root.querySelector("[data-hero-prev]");
    const next = root.querySelector("[data-hero-next]");
    const dotsWrap = root.querySelector("[data-hero-dots]");
    const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll("[data-hero-dot]")) : [];

    if (!track || slides.length <= 1) return;

    let i = 0;
    let timer = null;

    function render() {
      track.style.setProperty("--sv-hero-index", i);
      dots.forEach((d, idx) => d.classList.toggle("is-active", idx === i));
    }

    function go(n) {
      i = (n + slides.length) % slides.length;
      render();
    }

    function start() {
      stop();
      timer = setInterval(() => go(i + 1), 6000);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    prev && prev.addEventListener("click", () => { stop(); go(i - 1); start(); });
    next && next.addEventListener("click", () => { stop(); go(i + 1); start(); });

    dots.forEach((d) => {
      d.addEventListener("click", () => {
        const idx = parseInt(d.getAttribute("data-hero-dot"), 10);
        if (!Number.isNaN(idx)) {
          stop();
          go(idx);
          start();
        }
      });
    });

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);

    render();
    start();
  })();

  // -------------------------
  // Mobile drawer nav (burger)
  // -------------------------
  (function () {
    const burger = document.querySelector("[data-sv-burger]");
    const drawer = document.querySelector("[data-sv-drawer]");
    if (!burger || !drawer) return;

    const overlay = drawer.querySelector("[data-sv-drawer-overlay]");
    const closeBtn = drawer.querySelector("[data-sv-drawer-close]");

    function openDrawer() {
      drawer.classList.add("is-open");
      burger.setAttribute("aria-expanded", "true");
      document.documentElement.style.overflow = "hidden";
    }

    function closeDrawer() {
      drawer.classList.remove("is-open");
      burger.setAttribute("aria-expanded", "false");
      document.documentElement.style.overflow = "";
    }

    burger.addEventListener("click", () => {
      if (drawer.classList.contains("is-open")) closeDrawer();
      else openDrawer();
    });

    overlay && overlay.addEventListener("click", closeDrawer);
    closeBtn && closeBtn.addEventListener("click", closeDrawer);

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeDrawer();
    });

    drawer.addEventListener("click", (e) => {
      const a = e.target.closest("a");
      if (a) closeDrawer();
    });
  })();
})();